// extracted by mini-css-extract-plugin
export var screenItem = "screenItem-module--screenItem--3O90Z";
export var title = "screenItem-module--title--2dT-J";
export var list = "screenItem-module--list--1c-vr";
export var imgWrap = "screenItem-module--imgWrap--2o_Ft";
export var jsAnimInit = "screenItem-module--jsAnimInit--2bge-";